import { Outlet, useLocation } from "react-router-dom";
import BottomNav from "../components/BottomNav";

export default function AppLayout() {
  const location = useLocation();
  const isMap = location.pathname.startsWith("/map");
  return (
    <div className="relative min-h-screen w-full bg-[#050505] text-[#f5f5f5]">
      <main
        key={location.pathname}
        className={`zx-page-enter ${isMap ? "" : "pb-28 pt-2"} `}
        data-testid="app-main"
      >
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
